var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vel-badge"},[(_vm.position)?_c('el-badge',{attrs:{"value":_vm.value,"max":_vm.max,"is-dot":_vm.dot,"type":_vm.type}},[_vm._t("default")],2):_c('div',{staticClass:"vel-badge-inline"},[_c('el-badge',{staticClass:"vel-badge-inline-dot",attrs:{"is-dot":true,"type":_vm.type}}),_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }